import React from "react";
import { Select } from "@assets/spa/control/select";
import { ControlWrap } from "@assets/spa/control/wrap";
export function ForminatorTime(props) {
    const { errors, time_type, id, onChange, values, hh_label, hh_placeholder, mm_label, mm_placeholder, } = props;
    const hourOptCount = time_type === 'twentyfour' ? 24 : 12;
    const hhMessage = errors[`${id}-hours`];
    const mmMessage = errors[`${id}-minutes`];
    return React.createElement("div", { className: "ltg-forminator-field-time" },
        React.createElement(ControlWrap, { label: hh_label, message: hhMessage, valid: !hhMessage },
            React.createElement(Select, { value: values[`${id}-hours`], placeholder: hh_placeholder, options: new Array(hourOptCount).fill(null).map((_, i) => {
                    if (hourOptCount === 12)
                        i += 1;
                    return { label: i.toString().padStart(2, '0'), value: i.toString() };
                }), onChange: (val) => {
                    onChange(val, `${id}-hours`);
                } })),
        React.createElement(ControlWrap, { label: mm_label, message: mmMessage, valid: !mmMessage },
            React.createElement(Select, { placeholder: mm_placeholder, value: values[`${id}-minutes`], options: new Array(60).fill(null).map((_, i) => {
                    return { label: i.toString().padStart(2, '0'), value: i.toString() };
                }), onChange: (val) => {
                    onChange(val, `${id}-minutes`);
                } })),
        hourOptCount === 12 &&
            React.createElement(Select, { value: values[`${id}-ampm`], options: [
                    { label: 'AM', value: 'am' },
                    { label: 'PM', value: 'pm' },
                ], onChange: (val) => {
                    onChange(val, `${id}-ampm`);
                } }));
}
ForminatorTime.checkRequired = (props, values, __) => {
    const { id, required } = props;
    const errors = {};
    if (required !== "1")
        return errors;
    if (!values[`${id}-hours`])
        errors[`${id}-hours`] = __('Privalomas laukas', 'ltg-widgets');
    if (!values[`${id}-minutes`])
        errors[`${id}-minutes`] = __('Privalomas laukas', 'ltg-widgets');
    return errors;
};
